export const WORD_LENGTH: number = 5;
export const COUNT_WORDS: number = 5;
export const LS_NAME = '5words';
export const LS_CONFIG = '5wordsSettings';
